import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { AppRoute } from '@common/app/routes';
import {
  type NavigationItemsType,
  type NavigationLabelItemsType,
} from '@common/types/components';
import { StringXSmall } from '@components/Typography/Typography';
import cn from 'classnames';

import { checkIfClaimDateIsToday } from '@/common/lib/checkIfClaimDateIsToday';
import { MotionPicture } from '@/components/ui/Picture/Picture';
// import {
//   checkLevelToGetRewards,
//   getActiveReward,
// } from '@/redux/selectors/earnRewardsSelector';
import { timeLeftArenaOffer } from '@/redux/selectors/leagues';
// import { selectHasPendingPartnerTasks } from '@/redux/selectors/taskSelector';
import { checkHoldedBalance } from '@/redux/selectors/userSelectors';
import { useAppSelector } from '@/redux/store';

import { LeaguesNavigationItem } from './LeaguesNavigationItem';
import { LotteryNavigationItem } from './LotteryNavigationItem';
import { NavigationIcon } from './NavigationIcon';

import css from './styles.module.scss';

import dicePng from '/img/icons/dice.png';
import diceWebp from '/img/icons/dice.webp';

interface NavigationItemProps {
  name: NavigationItemsType;
  label: NavigationLabelItemsType;
  animationStep?: 1 | 2 | 3;
  className?: string;
}

const NavigationItem: FC<NavigationItemProps> = ({
  name,
  label,
  animationStep,
  className,
}) => {
  const dailyBonusHasVisit = useAppSelector(
    (state) => state.user.hasDailyBonusVisit,
  );
  const holdedBalance = useAppSelector(checkHoldedBalance);
  // const congruentLevel = useAppSelector(checkLevelToGetRewards);
  // const activeReward = useAppSelector(getActiveReward);
  // const nextClaimTime = useAppSelector(
  //   (state) => state.earnRewards.rewards?.nextClaimTime,
  // );
  // const earnRewardSeconds = useCountDownTimer(nextClaimTime || 0);
  const { t } = useTranslation();
  const links: Record<NavigationItemsType, string> = {
    partners: AppRoute.PARTNERS,
    friends: AppRoute.FRIENDS,
    rollCraft: AppRoute.GAME_CENTER,
    tickets: AppRoute.LOTTERY,
    arena: AppRoute.LEAGUES,
    shop: AppRoute.SHOP,
  };
  // const hasPendingPartnerTasks = useAppSelector(selectHasPendingPartnerTasks);
  const checkTimeLeftArenaOffer = useAppSelector(timeLeftArenaOffer);

  if (name === 'arena') {
    return <LeaguesNavigationItem className={className} />;
  }

  if (name === 'tickets') {
    return (
      <LotteryNavigationItem
        animationStep={animationStep}
        className={className}
      />
    );
  }

  const checkPoint = (): boolean => {
    switch (name) {
      // case 'lottery':
      //   return (
      //     !!(!earnRewardSeconds && congruentLevel && activeReward) ||
      //     hasPendingPartnerTasks
      //   );
      case 'partners':
        return (
          holdedBalance && !checkIfClaimDateIsToday('claim-holded-balance')
        );
      case 'shop':
        return (
          !dailyBonusHasVisit ||
          !checkIfClaimDateIsToday('claim-free-box-date') ||
          (checkTimeLeftArenaOffer && !sessionStorage.getItem('arenaShopCheck'))
        );
      default:
        return false;
    }
  };

  return (
    <NavLink to={links[name]} className={className}>
      <div
        className={css.navItem}
        // style={{ opacity: label === 'Rating' ? 0.3 : 1 }}
      >
        <div className="navigationIcon relative">
          <NavigationIcon name={name} />
          {name === 'rollCraft' && animationStep === 2 && (
            <MotionPicture
              layoutId="contract-complete-dice"
              transition={{ layout: { duration: 0.6, ease: 'easeOut' } }}
              img={dicePng}
              webp={diceWebp}
              className="w-[48px] h-[48px] rounded-full block absolute left-[8px] top-[18px]"
              style={{ zIndex: -2 }}
            />
          )}
        </div>
        <StringXSmall
          weight="medium"
          className={cn(
            'navigationText relative text-nowrap whitespace-nowrap',
          )}
        >
          {checkPoint() && (
            <div className="activeGreenPoint -top-[3%] -right-[3%]"></div>
          )}
          {t(label)}
        </StringXSmall>
      </div>
    </NavLink>
  );
};

export { NavigationItem };
